import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class IncidentsService {

  constructor(public httpClient: HttpClient) {}

  /* istanbul ignore next */
  private buildQueryParams(params?: string, incidentType?: string, skip: number = 0, limit: number = 100): HttpParams {
    const tenant = sessionStorage.getItem('tenant_'+sessionStorage.getItem('database')) || '';
    let queryParams = new HttpParams()
      .set('tenant', tenant)
      .set('incidentType', incidentType)
      .set('limit', String(limit))
      .set('skip', String(skip));

    if (params) {
      queryParams = queryParams.append('licencePlate', params);
    }

    return queryParams;
  }

  getSmokeIncidents(params?: string, skip: number = 0, limit: number = 100): Observable<any> {
    const url = `${environment.dashboardURL}/dashboard/incidents`;
    const queryParams = this.buildQueryParams(params, 'com.bosch.ivs.SmokeEvent', skip, limit);
    return this.httpClient.get(url, { params: queryParams });
  }

  getDamageIncidents(params?: string, skip: number = 0, limit: number = 100): Observable<any> {
    const url = `${environment.dashboardURL}/dashboard/incidents`;
    const queryParams = this.buildQueryParams(params, 'com.bosch.ivs.damage.DamageEvent', skip, limit);
    return this.httpClient.get(url, { params: queryParams });
  }

  getHarshDrivingIncidents(params?: string, skip: number = 0, limit: number = 100): Observable<any> {
    const url = `${environment.dashboardURL}/dashboard/incidents`;
    const queryParams = this.buildQueryParams(params, 'com.bosch.ivs.drivingbehaviour.DrivingBehaviourEvent', skip, limit);
    return this.httpClient.get(url, { params: queryParams });
  }

  openReport(incidentId): Observable<void> {
    const url = `${environment.apiReports}/download/${incidentId}`;
    return new Observable<void>(observer => {
      this.httpClient.get(url, { responseType: 'blob' }).subscribe({
        next: (blob: Blob) => {
          const objectUrl = URL.createObjectURL(blob);
          window.open(objectUrl, '_blank');
          observer.next();
          observer.complete();
        },
        error: (err) => observer.error(err)
      });
    });
  }
}
